import { render } from "./OrgLicensing.vue?vue&type=template&id=02ac47f7&ts=true"
import script from "./OrgLicensing.vue?vue&type=script&lang=ts"
export * from "./OrgLicensing.vue?vue&type=script&lang=ts"

import "./OrgLicensing.vue?vue&type=style&index=0&id=02ac47f7&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__